import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

// Only what profile/user-menu/capabilities read — not select('*').
const CURRENT_USER_COLUMNS = 'id, full_name, email, role, is_active'

export function useCurrentUser() {
  return useQuery({
    queryKey: ['current-user'],
    queryFn: async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser()
      if (!user) return null

      const { data, error } = await supabase
        .from('users')
        .select(CURRENT_USER_COLUMNS)
        .eq('id', user.id)
        .single()

      if (error) throw error
      return data
    },
  })
}
